<!--
2022-01-27 CHP Cash与Safe之间互转
-->
<template>
  <div class="page-container">
    <TopBack title="Back"/>
    <div class="nav">
      <div class="nav-item" :class="{active: type==='cash'}" @click="type = 'cash'">{{$t('lang.account.cash')}}</div>
      <div class="nav-item" :class="{active: type==='safe'}" @click="type = 'safe'">{{$t('lang.account.safe')}}</div>
    </div>
    <div class="tab" v-show="type==='cash'">
      <div class="caption" style="margin-top: 15px">
        <span>{{$t('lang.account.cashBalance')}}</span>
      </div>
      <div class="cash" style="margin-top: 15px">
        <span>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Cash+this.accountInfo.Gift)}}</span>
      </div>
      <div class="transfer-icon-wrapper">
        <div class="left" style="flex: 1;">
          <img :src="line" class="line">
        </div>
        <div class="center" style="flex: 1">
          <img :src="transfer3" class="icon">
        </div>
        <div class="right" style="flex: 1;">
          <img :src="line" class="line">
        </div>
      </div>
      <div class="transfer-to-wrapper">
        <div class="text">
          <span>{{$t('lang.account.transferTo')}}</span>
        </div>
        <div class="box">
          <div class="box-inner">
            <span>{{$t('lang.account.safe')}}</span>
          </div>
        </div>
      </div>
      <div class="transfer-input-wrapper">
        <input placeholder="Input amount to transfer"
               class="transfer-input"
               v-model="transferToSafeAmount" type="number"/>
      </div>
      <div class="transfer-btn" @click="transferToSafe">
        <div class="btn-inner">
          <img :src="transfer1" class="icon">
          <span class="text">{{$t('lang.account.transfer')}}</span>
        </div>
      </div>
    </div>
    <div class="tab" v-show="type==='safe'">
      <div class="caption" style="margin-top: 15px">
        <span>{{$t('lang.account.safeBalance')}}</span>
      </div>
      <div class="cash" style="margin-top: 15px">
        <span>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Wallet)}}</span>
      </div>
      <div class="transfer-icon-wrapper">
        <div class="left" style="flex: 1;">
          <img :src="line" class="line">
        </div>
        <div class="center" style="flex: 1">
          <img :src="transfer3" class="icon">
        </div>
        <div class="right" style="flex: 1;">
          <img :src="line" class="line">
        </div>
      </div>
      <div class="transfer-to-wrapper">
        <div class="text">
          <span>{{$t('lang.account.transferTo')}}</span>
        </div>
        <div class="box">
          <div class="box-inner">
            <span>{{$t('lang.account.cash')}}</span>
          </div>
        </div>
      </div>
      <div class="transfer-input-wrapper">
        <input :placeholder="$t('lang.account.inputAmount')"
               class="transfer-input" v-model="transferToCashAmount"
               type="number"/>
      </div>
      <div class="transfer-btn" @click="transferToCash">
        <div class="btn-inner">
          <img :src="transfer1" class="icon">
          <span class="text">{{$t('lang.account.transfer')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {separateThousand, getUTCNow} from '@/utils'
import {fetchCurrency} from '@/constant'
import TopBack from '@/components/TopBack/index'
import request from '@/service'
import transfer1 from '@/assets/images/account/transfer.png'
import transfer3 from '@/assets/images/account/transfer3.png'
import line from '@/assets/images/account/line.png'
import {Toast} from 'mint-ui'

export default {
  name: 'transfer',
  components: {
    TopBack
  },
  data () {
    return {
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      accountInfo: {},
      type: 'cash',
      fetchCurrency,
      separateThousand,
      getUTCNow,
      transfer1,
      transfer3,
      line,
      transferToSafeAmount: null,
      transferToCashAmount: null
    }
  },
  watch: {
    transferToSafeAmount: function (val) {
      this.transferToSafeAmount = val.replace(/\D/g, '')
    },
    transferToCashAmount: function (val) {
      this.transferToCashAmount = val.replace(/\D/g, '')
    }
  },
  mounted () {
    this.fetchAccount()
  },
  methods: {
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data).then(res => {
          console.log(res)
          this.accountInfo = res
          this.whatsappShareLnk = 'whatsapp://send?text=' + encodeURIComponent(this.accountInfo.InviteLink)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    transferToSafe: function () {
      if (!this.transferToSafeAmount) {
        Toast(this.$t('lang.account.inputAmount'))
        return
      }

      if (this.transferToSafeAmount > Math.floor(this.accountInfo.Cash)) {
        Toast(this.$t('lang.account.transferExceedLimit') +
              this.fetchCurrency[this.userInfo.CurrencyName] +
              this.separateThousand(this.accountInfo.Cash))
        return
      }

      const url = '/innovation/account/converttosafe'
      const data = {
        userId: this.userInfo.UserId,
        amount: this.transferToSafeAmount
      }
      request('post', url, data).then(res => {
        console.log(res)
        switch (res.Code) {
          case 1:
            this.accountInfo = {
              ...this.accountInfo,
              ...res
            }
            Toast(this.$t('lang.account.transferSuccess'))
            this.transferToSafeAmount = null
            break
          case -3:
            this.accountInfo = {
              ...this.accountInfo,
              ...res
            }
            Toast(this.$t('lang.account.safeOnlyForDeposit'))
            break
          case -1:
            this.accountInfo = {
              ...this.accountInfo,
              ...res
            }
            Toast(this.$t('lang.account.transferExceedLimit') +
              this.fetchCurrency[this.userInfo.CurrencyName] +
              this.separateThousand(this.accountInfo.Cash))
            break
          case -2:
            Toast(this.$t('lang.account.transferError'))
            break
        }
      }).catch(err => {
        console.log(err)
      })
    },
    transferToCash: function () {
      if (!this.transferToCashAmount) {
        Toast(this.$t('lang.account.inputAmount'))
        return
      }

      if (this.transferToCashAmount > Math.floor(this.accountInfo.Wallet)) {
        Toast(this.$t('lang.account.transferExceedLimit') +
          this.fetchCurrency[this.userInfo.CurrencyName] +
          this.separateThousand(this.accountInfo.Wallet))
        return
      }

      const url = '/innovation/account/converttocash'
      const data = {
        userId: this.userInfo.UserId,
        amount: this.transferToCashAmount
      }
      request('post', url, data).then(res => {
        console.log(res)
        switch (res.Code) {
          case 1:
            this.accountInfo = {
              ...this.accountInfo,
              ...res
            }
            Toast(this.$t('lang.account.transferSuccess'))
            this.transferToCashAmount = null
            break
          case -1:
            this.accountInfo = {
              ...this.accountInfo,
              ...res
            }
            Toast(this.$t('lang.account.transferExceedLimit') +
              this.fetchCurrency[this.userInfo.CurrencyName] +
              this.separateThousand(this.accountInfo.Wallet))
            break
          case -2:
            Toast(this.$t('lang.account.transferError'))
            break
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log('test111111')
      console.log(to.query.type)
      if (to.query.type) {
        vm.type = to.query.type
      }
    })
  }
}
</script>

<style scoped lang="less">
  .page-container{
    .nav{
      display: flex;
      margin: 30px 10px 20px 10px;
      border-radius: 6px;
      justify-content: space-around;
      /*border: 1px solid rgba(246, 217,170, 0.5);*/
      font-size: 20px;
      font-weight: bold;

      .nav-item{
        width: 75px;
        line-height: 30px;
        text-align: center;
        color: rgba(246, 217, 170, 0.5);
      }

      .active{
        width: 75px;
        border-bottom: 2px solid #F6D9AA;
        color: #F6D9AA;
      }
    }

    .tab{
      padding-bottom: 70px;

      .caption{
        font-size: 20px;
        font-weight: bold;
        color: #F6D9AA;
        line-height: 35px;
        text-align: center;
      }
      .cash{
        font-size: 26px;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.6);
        line-height: 35px;
        text-align: center;
      }

      .transfer-icon-wrapper{
        display: flex;
        justify-content: space-between;
        margin: 15px 0px;

        .left {
          flex: 1;
          height: 60px;
          position: relative;
          text-align: right;
          .line{
            width: 50px;
            height: 2px;

            position: absolute;
            top: 50%;
            right: 0%;
            transform: translate(0%, -50%);
          }
        }

        .right {
          flex: 1;
          height: 60px;
          position: relative;
          text-align: left;
          .line{
            width: 50px;
            height: 2px;

            position: absolute;
            top: 50%;
            left: 0%;
            transform: translate(0%, -50%);
          }
        }

        .center {
          flex: 1;
          height: 60px;
          position: relative;
          text-align: center;

          .icon{
            width: 50px;
            height: 50px;

            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }

      .transfer-to-wrapper{
        .text{
          color: rgba(246, 217, 170, 0.7);
          font-size: 16px;
          text-align: center;
        }

        .box {
          margin-top: 5px;
          text-align: center;

          .box-inner {
            font-size: 22px;
            font-weight: bold;
            width: 80px;
            border: 2px solid #F6D9AA;
            padding: 5px 0px;
            border-radius: 6px;
            margin: 0 auto;
            color: #F6D9AA;
          }
        }
      }

      .transfer-input-wrapper {
        margin: 10px 16px;

        .transfer-input {
          background: #000000;
          color: #FFFFFF;
          text-align: center;
          border-radius: 6px;
          padding: 6px 0px;
          font-size: 18px;
          width: 100%;
          line-height: 30px;
        }
      }

      .transfer-btn {
        margin: 15px 16px 50px 16px;
        background: #F6D9AA;
        border-radius: 6px;
        text-align: center;
        position: relative;
        height: 40px;

        .btn-inner {
          display: flex;
          margin: 0 auto;
          line-height: 25px;

          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          .icon {
            height: 19px;
            margin: 3px 8px 3px 0px;
            display: block;
          }

          .text{
            color: #000000;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Account/transfer.vue